import { Button } from '@simplywallst/ui-core';
import useCopyUrlToClipboard from '@/pages/CompanyReport/hooks/useCopyUrlToClipboard';
import CopyLinkOutline from '@simplywallst/ui-core/icons/CopyLinkOutline';

export const ShareNarrative = () => {
  const copyUrlToClipboard = useCopyUrlToClipboard();

  return (
    <Button
      alignIcon="left"
      display="inline"
      styleType="gentle"
      className="!pl-7 sm:!pl-9"
      onClick={copyUrlToClipboard}
    >
      <CopyLinkOutline aria-label="Share" />
      <span className="hidden sm:inline">Share</span>
    </Button>
  );
};
